import React, { forwardRef, Fragment, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { Box, DialogContent } from '@mui/material';
import Feed from '../feed';
import { DOMAIN } from '../../config';
import CustomizedProgressBars from '../common/loading';
import AppSnackbar from "../common/appSnackbar.jsx";
import SearchOffIcon from '@mui/icons-material/SearchOff';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export default function SearchRecommand({ openSearch = false, setOpenSearch, matches, chipTitle }) {
  const [latest, setLatest] = useState([]);
  const [empty, setEmpty] = useState(false);
  const [loading, setLoading] = useState(true);

  // 判断是否需要显示 remark
  const isRemark = ["淫妻","淫妻绿帽","东京热","Sperm","夜未央","周排行榜","科幻","ED Mosaic"].includes(chipTitle);

  const handleClose = () => setOpenSearch(false);

  useEffect(() => {
    if (!openSearch) return;

    setLatest([]);
    setEmpty(false);
    setLoading(true);

    // 初始加载
    fetch(`${DOMAIN}ywyminiappbot/getVideoById?id=${chipTitle}&page=1`)
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (!data || data.length === 0) {
          setEmpty(true);
        } else {
          setLatest(data);
        }
      });
  }, [openSearch, chipTitle]);

  return (
    <Fragment>
      <Dialog
        fullScreen
        open={openSearch}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppSnackbar message={"向左 👈 滑动可快速关闭本页面"} vertical={"bottom"} />

        <AppBar sx={{ position: 'sticky' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              店长推荐
            </Typography>
            <Button autoFocus color="inherit" sx={{ textTransform: 'lowercase' }}>
              52ywy.com
            </Button>
          </Toolbar>
        </AppBar>

        <DialogContent sx={{ padding: 0 }}>
          {latest.length > 0 && (
            <Feed
              matches={matches}
              latest={latest}
              setLatest={setLatest}
              fetchUrl={`${DOMAIN}ywyminiappbot/search?caption=${chipTitle}`}
              title={chipTitle}
              remark={isRemark}
            />
          )}

          {loading && <CustomizedProgressBars />}

          {empty && (
            <Box sx={{
              display: "flex",
              justifyContent: "center",
              flexFlow: "row",
              padding: "200px 0",
              color: "#999"
            }}>
              <SearchOffIcon />
              <Typography variant='h6' fontSize={14}>
                没有此内容，我们会尽快发布...
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
